import React from "react";

export default function CardProductosOne({ title, img, description, icon }) {
  const apiUrl = process.env.REACT_APP_STRAPI_URL;

  const renderTextNode = (node, key) => {
    const { text, bold, italic } = node;

    if (!text) return null;

    let element = <span key={key}>{text}</span>;

    if (bold && italic) {
      element = (
        <strong key={key}>
          <em>{text}</em>
        </strong>
      );
    } else if (bold) {
      element = <strong key={key}>{text}</strong>;
    } else if (italic) {
      element = <em key={key}>{text}</em>;
    }

    return element;
  };

  const renderParagraph = (block, idx) => {
    if (block.type !== "paragraph" || !Array.isArray(block.children))
      return null;

    return (
      <p key={idx} className="text-sidom-light text-sm">
        {block.children.map((child, i) => {
          if (
            child.type === "link" &&
            child.url &&
            Array.isArray(child.children)
          ) {
            return (
              <a
                key={i}
                href={child.url}
                className="text-sidom-blue "
                target="_blank"
                rel="noopener noreferrer"
              >
                {child.children.map((subChild, j) =>
                  renderTextNode(subChild, j)
                )}
              </a>
            );
          }

          return renderTextNode(child, i);
        })}
      </p>
    );
  };

  return (
    <div className="bg-sidom-orange rounded-xl h-[400px] w-full sm:w-[320px] overflow-hidden shadow-lg hover:shadow-2xl">
      <div className="relative">
        <img
          src={`${apiUrl}${img}`}
          alt={title}
          className=" w-full sm:w-[320px] h-[200px] object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent">
          <div className="absolute bottom-4">
            <div className="flex px-12 w-full flex-col items-start justify-start">
              <div className="rounded-full flex items-center justify-center">
                <img src={`${apiUrl}${icon}`} className="w-8 h-8" alt={title} />
              </div>
              <h1 className="text-xl font-bold text-white whitespace-nowrap">
                {title}
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div className="px-12 mt-[30px] text-left">
        {Array.isArray(description) ? (
          description.map((block, idx) => renderParagraph(block, idx))
        ) : (
          <p className="text-sidom-light text-sm">
            {description || "Sin descripción"}
          </p>
        )}
      </div>
    </div>
  );
}
